import { BaseService } from "@/api/base-service";
import type {
  GymsResponse,
  GymDisciplinesResponse,
  GymExercisesResponse,
  GymResourceStatus,
} from "./types";

export class GymsService extends BaseService {
  static get instance() {
    return this.getInstance<GymsService>();
  }

  public async getGyms(): Promise<GymsResponse> {
    return this.client.get<GymsResponse>("/gyms");
  }

  public async getGymDisciplines(
    id: number,
    status: GymResourceStatus,
  ): Promise<GymDisciplinesResponse> {
    return this.client.get<GymDisciplinesResponse>(
      `/gyms/${id}/gym_disciplines?status=${status}`,
    );
  }

  public async updateGymDisciplines(
    gymId: number,
    disciplineIds: number[],
  ): Promise<void> {
    return this.client.patch(`/gyms/${gymId}/gym_disciplines`, {
      disciplineIds,
    });
  }

  public async getGymExercises(
    id: number,
    status: GymResourceStatus,
  ): Promise<GymExercisesResponse> {
    return this.client.get<GymExercisesResponse>(
      `/gyms/${id}/gym_exercises?status=${status}`,
    );
  }

  public async updateGymExercises(
    gymId: number,
    exerciseIds: number[],
  ): Promise<void> {
    return this.client.patch(`/gyms/${gymId}/gym_exercises`, {
      exerciseIds,
    });
  }
}
